'use strict';

// Quickview helper functions that are used by both quickview.js and variant.js to avoid circular dependencies

var quickviewHelpers = {
    renderQuickViewReviews: function () {
        document.dispatchEvent(new Event('renderPR'));
        // Watch for pr-reviewsnippet to be rendered and then copy the contents into pr-reviewsnippet-mobile
        const observer = new MutationObserver(() => {
            let reviewSnippet = document.querySelector('#pr-reviewsnippet');
            let mobileReviewSnippet = document.querySelector('#pr-reviewsnippet-mobile');
            if (reviewSnippet && reviewSnippet.innerHTML && reviewSnippet.innerHTML.indexOf('pr-review-snippet-container') > -1 && mobileReviewSnippet) {
                mobileReviewSnippet.innerHTML = reviewSnippet.innerHTML;
                observer.disconnect();
            }
        });
        observer.observe(document.body, { childList: true, subtree: true });
    }
};

module.exports = quickviewHelpers;
